import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/services/app/app.service';
import { CourseService } from 'src/app/services/course/course.service';
import { IndividualService } from 'src/app/services/individual/individual.service';
import { CourseComplettionComponent } from '../course-complettion/course-complettion.component';
import { MatDialog } from '@angular/material/dialog';
import { CourseCompletionService } from 'src/app/services/course-completion/course-completion.service';
import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService } from 'src/app/services/global/global.service';

@Component({
  selector: 'app-individual-exam',
  templateUrl: './individual-exam.component.html',
  styleUrls: ['./individual-exam.component.scss']
})
export class IndividualExamComponent {
  public getCurrentTime = new Date().getTime();
  public isSpinnerLoading: boolean = false;
  public questionArr: any[] = [
    {
      title: "",
      ans_arr: [1, 2, 3, 4]
    }
  ]
  countdown: number = 10;
  formattedCountdown
  timerInterval: any;
  public currentQue: any
  public currentQueIndex: number = 1;
  public paramsData: any
  public examType: any;
  // public isResultShow: boolean = false;
  public resultData: any;
  public isAllSectionCompleted: boolean = false;
  public isSetExam: boolean = false;
  // @Input() courseData!:any;
  // @Output() trackEvent = new EventEmitter<any>(); 
  // @Output() resultEvent = new EventEmitter<any>(); 
  // @Input() isResultShow!:boolean;
  @Output() childEvent = new EventEmitter<any>(); 
  @Input() childData!:any;
  public isCourseViewOnly:boolean=false;
  public imageURL:string =GlobalService.imageURL ;
  // @Input() childDataType!:any;
  constructor(private courseService: CourseService, private appService: AppService, private individualService: IndividualService, public dialog: MatDialog,
    private activatedRoute: ActivatedRoute, private router: Router, private courseCompletionService: CourseCompletionService, private commonService: CommonService) { }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // this.startCountdown()
    this.commonService.setTitle("Courses")
    let params;
    this.isSpinnerLoading=true;
    setTimeout(() => { 
      if(this.childData.type=='view_exam'){
        this.getViewQuestionList()
      }
      else{
      if(this.childData && this.childData.exam_data){
        params=this.childData.exam_data;
        let dataObj = {
          "c_i": params["c_i"],
          "p_i": params["p_i"],
          "e_i": params["e_i"],
          "s_i": params["s_i"],
          "s_si": params["s_si"],
          "p_si": params["p_si"],
          "c_t": params["c_t"]
        }
        this.paramsData = dataObj;
        if(this.childData.type=='exam'){
          this.getQuestionList(dataObj)
        }
        if(this.childData.type=='result'){
          this.resultData=this.childData.result_data;
        }
        if(this.childData.result_data &&this.childData.result_data["is_cs"]==true){
         this.isAllSectionCompleted=true
        }
      }
      else{
        this.isCourseViewOnly=true;
        this.questionArr= [
            {
                "id": 218,
                "question": "How many wonders in the world",
                "question_image": "",
                "option_1": 5,
                "option_2": 6,
                "option_3": 7,
                "option_4": 8
            },
            {
                "id": 219,
                "question": "How many spokes does Ashok chakra have ?",
                "question_image": "",
                "option_1": 24,
                "option_2": 25,
                "option_3": 26,
                "option_4": 27
            },
            {
                "id": 217,
                "question": "what  is capital of India",
                "question_image": "",
                "option_1": "Delhi",
                "option_2": "Surat",
                "option_3": "Jaipur",
                "option_4": "Udaipur"
            }
        ];
        this.currentQue = this.questionArr[0]
        this.startCountdown()
      }
      this.examType=this.childData.data.e_t
      this.isSpinnerLoading=false;
    }

    },300);
  }
  onBack() { }
  calculatePercentage() {
    return (this.currentQueIndex / this.questionArr.length) * 100
  }
  startCountdown() {
    // user will get 30 sec to answer the question if he doexn't answer then next question 
    this.countdown = 30;
    this.timerInterval = setInterval(() => {
      // console.clear();
      this.formattedCountdown = this.countdown < 10 ? `0${this.countdown}` : this.countdown;
      this.countdown--;
      if (this.countdown < 0) {
        clearInterval(this.timerInterval);
        this.nextQuestion()
      }
    }, 1000);
  }
  nextQuestion() {
    clearInterval(this.timerInterval);
    if (this.currentQueIndex < this.questionArr.length) {
      this.startCountdown()
      this.currentQueIndex = this.currentQueIndex + 1;
      this.currentQue = this.questionArr[this.currentQueIndex - 1];
    }
    // else if (this.currentQueIndex==this.questionArr.length){
    //   this.startCountdown()
    // }
    else {
      this.onSubmitAnswer()
      // this.onSubmitSectionExam()
    }
  }
  getQuestionList(data) {
    let objData = {
      c_i: parseInt(this.paramsData.c_i),
      e_i: parseInt(this.paramsData.e_i),
      p_i: parseInt(this.paramsData.p_i),
      t: this.paramsData.c_t
    }
    this.isSpinnerLoading = true;
    this.individualService.getExam(objData).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        if (success.status == 200) {
          // rest both this two things whenever reset the exam
          this.questionArr=[];
          this.currentQueIndex=1;

          this.questionArr = success["data"]["ques"]
          this.questionArr.map(item => item["ans"] = '')
          this.currentQue = this.questionArr[0]
       
          this.startCountdown()
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    }
    )
  }
  getViewQuestionList(){
    // let userData = JSON.parse(this.appService.getData('training-portal.userInfo'))
    // this.userType = userData.group_type;
    let obj={
      c_i:'',
      login_type:'',
      e_i:this.childData.e_i
    }  
    this.isSpinnerLoading = true;
    this.courseService.viewExam(obj).subscribe((success:any)=>{
      if(success.status==200){
        this.isSpinnerLoading=false;
        this.questionArr=[];
        this.currentQueIndex=1;
  
        this.questionArr = success["msg"]["que"]
        this.questionArr.map(item => item["ans"] = '')
        this.onViewArr()
        this.currentQue = this.questionArr[0]
     
        this.startCountdown()
      }
    
    },(error)=>{})
  }
  onViewArr(){
    this.questionArr.map(item=>{
      item["id"]=item["que_id"]
      item["que"]=item["qn"]
      item["op_1"]=item["ansArr"][0]["option"]
      item["op_2"]=item["ansArr"][1]["option"]
      item["op_3"]=item["ansArr"][2]["option"]
      item["op_4"]=item["ansArr"][3]["option"]
    })
  }
  onSelectAns(value) {
    this.currentQue["ans"] = value
    this.questionArr[this.currentQueIndex - 1]["ans"] = value
    // this.currentQue["answer"]=value/
  }
  onSubmitAnswer() {
    const newArray = this.questionArr.map((item) => ({
      id: item.id,
      ans: item.ans
    }));
    let data = {
      // course_id:37,
      // exam_id: 33,
      // purchase_id:14,
      // answers:newArray
    }

    if(this.childData.type=="view_exam"){
      this.sendToCoursePreview("exam_submitted","")
    }
    else{
      if (this.examType == "f"||this.examType=='final') {
        this.onSubmitOverallExam(newArray)
      }
      else {
        //overall Exam
        // this.onSubmitOverallExam(newArray)
        this.onSubmitSectionExam()
      }
    }
  
  }
  onSubmitSectionExam() {
    var getSecondDiff = (new Date().getTime() - this.getCurrentTime) / 1000;
    const newArray = this.questionArr.map((item) => ({
      id: item.id,
      ans: item.ans
    }));
    let data ;
    if(!this.isCourseViewOnly){
      data={
        p_i: parseInt(this.paramsData.p_i),
        c_i: parseInt(this.paramsData.c_i),
        s_si: parseInt(this.paramsData.s_si),
        s_i: parseInt(this.paramsData.s_i),
        sp_ti: Math.abs(Math.round(getSecondDiff)),
        t: this.paramsData.c_t,
        track_data: [
          {
            e_i: parseInt(this.paramsData.e_i),
            s_si: this.paramsData.s_si,
            anss: newArray
          }
        ]
      }
      this.sendToCoursePreview('exam',data["track_data"])
    }
    else{
      data={
        sp_ti: Math.abs(Math.round(getSecondDiff)),
        ans: newArray
      }
      this.sendToCoursePreview('exam',data)
    }
  }
  sendToCoursePreview(type:string,data:any){
    let edata={
      type:type,
      data:data
    }
    this.childEvent.emit(edata)
  }
  onSubmitOverallExam(newArray) {
    let data = {
      c_i: parseInt(this.paramsData.c_i),
      e_i: parseInt(this.paramsData.e_i),
      p_i: parseInt(this.paramsData.p_i),
      anss: newArray,
      t: this.paramsData.c_t
    }
    this.isSpinnerLoading = true;
    this.individualService.result(data).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        if (success.status == 200) {
          // this.isResultShow = true;
           this.resultData = success["data"]
           this.sendToCoursePreview('result',success["data"])
           
          //  if overall exam then setting all section completed as true
          this.isAllSectionCompleted=true
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        // this.appService
        this.commonService.handleError(error)
      }
    })
  }
  onExamList() {
    let data = {
      c_i: parseInt(this.paramsData.c_i),
      p_i: parseInt(this.paramsData.p_i),
      t: this.paramsData.c_t
    }
    this.router.navigate(['/individual/my-course/exam-list'], { queryParams: data })
  }
  onNextSection(){
    let data={
      type:'result_shown'
    }
    this.childEvent.emit(data)
  }
  onGoToExamList(){
    let data={
      type:'go_to_examList'
    }
    this.childEvent.emit(data)
  }
  onResetExam(){
  //  this.sendToCoursePreview('reset','')
    // this.childDataType="exam"
  this.childData.type='exam'
  this.getQuestionList(this.childData.exam_data)
  }
  onCertDownload(item){
    this.appService.downloadFile(item,'certificate')
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    clearInterval(this.timerInterval);
    this.appService.removeSessionData('sectionArr')
  }
}